<mat-form-field
  color="accent"
  [style.width]="fullWidth ? '100%' : width"
  [appearance]="appearance"
  [floatLabel]="floatPlaceholder"
>
  <mat-label>{{ label }}</mat-label>
  <input
    #dateInput
    matInput
    [matDatepicker]="picker"
    [min]="min"
    [max]="max"
    [id]="inputId"
    [name]="inputId"
    [required]="required"
    [formControl]="_formControl"
    [autocomplete]="autocomplete"
    (keydown)="callKeydown($event)"
    (dateInput)="onInputChange($event)"
    (input)="onInput($event)"
    (blur)="onBlur($event)"
  />

  <mat-datepicker-toggle matIconSuffix [for]="picker" />
  <mat-datepicker #picker [startAt]="startAtDate" [startView]="startViewOption" [touchUi]="!media.isActive('gt-md')" />

  @if (_formControl.invalid && (_formControl.dirty || _formControl.touched)) {
    <mat-error>{{ getErrorMessage() }}</mat-error>
  }

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>

<!--  <div *ngIf="isInvalid()">{{ getErrorMessage() }}</div>-->
